import { useContext } from 'react';
import { InvestigationModalContext } from '.';

export const useInvestigationModal = () => {
    const investigationModalContext = useContext(InvestigationModalContext);
    return investigationModalContext;
};
